import type { useToast } from '@rematter/ui-web/hooks';

import { tradeRoutePaths } from '../routes';

/**
 * Handles actionable errors that contain booking URLs.
 * If the error message contains a booking URL, it shows a toast with an action button
 * that navigates to the booking detail page. Otherwise, it shows a standard error toast.
 *
 * @param error - The error to handle
 * @param toast - The toast instance from useToast
 * @param navigate - The navigate function from useModuleLocation
 */
export const handleActionableError = (
  error: unknown,
  toast: ReturnType<typeof useToast>,
  navigate: ReturnType<
    typeof import('~/shared/hooks/useModuleLocation').useModuleLocation
  >[1],
) => {
  const errorMessage = error instanceof Error ? error.message : String(error);

  // Check if error contains a booking URL and extract the booking ID
  const urlMatch = errorMessage.match(/\/sales\/bookings\/([\w-]+)/);

  if (urlMatch) {
    const bookingId = urlMatch[1];
    const bookingUrl = urlMatch[0];

    // Remove the URL from the message and clean up
    const mainMessage = errorMessage
      .replace(bookingUrl, '')
      .trim()
      .replace(/\s+/g, ' ')
      .replace(/\.\s*$/, '.');

    // Show error toast with action to navigate to booking
    toast.error(mainMessage, undefined, {
      action: {
        label: 'Link SO to Booking',
        onPress: () => {
          navigate(tradeRoutePaths.bookingDetail, {
            params: { id: bookingId },
          });
        },
      },
    });
  } else {
    // For other errors, show toast without action
    toast.error(errorMessage);
  }
};
